/* eslint no-mixed-operators: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import moment from 'moment';
import lodash from 'lodash';
import classnames from 'classnames';
import AccessorialRequestActionCreators from 'actions/AccessorialRequestActionCreators';
import ShipmentWebAPIUtils from 'utils/ShipmentWebAPIUtils';
import ExceptionStore from 'stores/ExceptionStore';
import SessionStore from 'stores/SessionStore';
import ConfirmModal from 'components/ui/modals/ConfirmModal';
import { Glyphicon, OverlayTrigger, Tooltip } from 'react-bootstrap';
import DataPoller from 'components/ui/DataPoller';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';
import { getShipmentTimezone } from 'helpers/shipments';
import formatMoney from 'utils/formatters/Money';
import CargomaticAlert from 'components/ui/Alert';
import ExclamationIcon from 'components/v2/icons/ExclamationIcon';
import { getAccessorialRequestsAutoDeclineDates } from 'utils/AccessorialRequestWebAPIUtils';
import { showToast } from 'stores/ToastStore';
import AccessorialDocumentUploadModal from './AccessorialDocumentUploadModal';
import Spinner from '../../ui/Spinner';
import AddButton from '../../v2/buttons/AddButton';
import Badge from '../../v2/Badge';
import CargomaticModal from '../../v2/modal';
import AccessorialRequestForm from './AccessorialRequestForm';
import { sluggify } from '../../../utils/localization/utils';
import { isShipmentCanceled } from 'helpers/shipments';
import { withLocaleContext } from 'providers/locale-settings-context';
const Loading = () => (React.createElement("div", { className: "w-full" },
    React.createElement("div", { className: "" },
        React.createElement("span", { className: "justify-center text-5xl text-green" },
            React.createElement(Spinner, { showMessage: false })))));
const VIEW_HEADERS = [
    'ACCESSORIAL',
    'TOTAL',
    'ENTERED',
    'STATUS',
    'REMARK',
    'UPDATED',
];
if (SessionStore.isCarrier()) {
    VIEW_HEADERS.push('MISSING_DOCUMENTS_QUESTION');
}
const POLL_INTERVAL = 8000;
class ViewAccessorialRequests extends Component {
    constructor(props) {
        super(props);
        this.onChange = async () => {
            try {
                const { updates } = this.state;
                const { isShipper, isCarrier, job } = this.props;
                let exceptions = ExceptionStore.getAllAccessorialRequests();
                if (isShipper) {
                    exceptions = lodash.filter(exceptions, (exception) => {
                        if (!exception.shipment) {
                            return false;
                        }
                        return (exception.shipment._id === job._id &&
                            exception.shipper_status !== 'pending-admin');
                    });
                }
                else if (isCarrier) {
                    exceptions = lodash.filter(exceptions, (exception) => {
                        if (!exception.shipment || !exception.carrier_cost) {
                            return false;
                        }
                        return (exception.shipment._id === job._id &&
                            (parseFloat(exception.carrier_cost) > 0.0 ||
                                parseFloat(exception.carrier_cost) < 0.0));
                    });
                }
                else {
                    exceptions = lodash.filter(exceptions, (exception) => {
                        if (!exception.shipment) {
                            return false;
                        }
                        return exception.shipment._id === job._id;
                    });
                }
                let units;
                let rate;
                let total;
                const accessorialRequestIdsMissingDocs = exceptions
                    .filter((e) => e.missing_docs)
                    .map((e) => e._id);
                let accessorialAutoDeclineDates = {};
                if (featureEnabled(CONFIGURED_FEATURES.SSR) &&
                    accessorialRequestIdsMissingDocs &&
                    accessorialRequestIdsMissingDocs.length) {
                    accessorialAutoDeclineDates = await this.getShipperAutoDeclineDates(accessorialRequestIdsMissingDocs);
                }
                const rows = exceptions.map((item) => {
                    if (isShipper) {
                        units = item.shipper_unit_qty || 0;
                        rate = item.shipper_rate || 0;
                    }
                    else {
                        units = item.carrier_unit_qty || 0;
                        rate = item.carrier_rate || 0;
                    }
                    total = units * rate;
                    const shipperAutoDeclineDate = accessorialAutoDeclineDates[item._id.toString()];
                    const mapExceptionsToTable = {
                        _id: item === null || item === void 0 ? void 0 : item._id,
                        accessorial: item.message,
                        accessorial_type: item === null || item === void 0 ? void 0 : item.accessorial_type,
                        status: isShipper ? item.shipper_status : item.carrier_status,
                        updated: item.modified_at,
                        units: `${units}`,
                        created: item.created_at,
                        id: item._id,
                        shipper_rate: item.shipper_rate || 0,
                        shipper_status: item.shipper_status,
                        carrier_status: item.carrier_status,
                        shipment: item.shipment,
                        carrier_note: (item.carrier_status === 'declined' &&
                            item.carrier_decline_reason_code) ||
                            item.carrier_note ||
                            '',
                        missing_docs: item.missing_docs,
                        rate,
                        total,
                        shipperAutoDeclineDate,
                    };
                    return Object.assign(mapExceptionsToTable);
                });
                this.setState({
                    loading: false,
                    updates,
                    rows,
                });
            }
            catch (e) {
                console.error('Error on accessorial request change: ', e.message);
            }
        };
        this.getShipperAutoDeclineDates = async (accessorialRequestIds) => {
            var _a;
            const { t } = this.props;
            try {
                const result = await getAccessorialRequestsAutoDeclineDates(accessorialRequestIds);
                const items = ((_a = result === null || result === void 0 ? void 0 : result.entity) === null || _a === void 0 ? void 0 : _a.items) || [];
                return items.reduce((dates, { _id, shipper_auto_decline_date }) => {
                    dates[_id] = shipper_auto_decline_date;
                    return dates;
                }, {});
            }
            catch (e) {
                showToast(t('ACCESSORIAL_REQUEST_ERROR'), t('ERROR_RETRIEVING_SHIPPER_ACCESSORIAL_REQUEST_AUTO_DECLINE_DATE'), 'error');
                console.error(`Error retrieving shipper accessorial request auto decline date: ${e.message}`);
                return {};
            }
        };
        this.removeAccessorial = (accessorial) => {
            const id = accessorial.id;
            const exceptions = ExceptionStore.getAllAccessorialRequests();
            const toDelete = _.findWhere(exceptions, { _id: id });
            if (toDelete) {
                this.props.removeAccessorial(toDelete);
            }
        };
        this.showUploadModal = (accessorial) => {
            this.setState({ showUploadModal: true, selectedAccessorial: accessorial });
        };
        this.hideUploadModal = () => {
            this.setState({ showUploadModal: false, selectedAccessorial: null });
        };
        this.state = {
            rows: [],
            loading: true,
            showUploadModal: false,
            selectedAccessorial: null,
        };
    }
    componentDidMount() {
        AccessorialRequestActionCreators.getAccessorialRequests(this.getRequest());
        ExceptionStore.addChangeListener(this.onChange);
    }
    componentWillUnmount() {
        ExceptionStore.removeChangeListener(this.onChange);
    }
    getRequest() {
        if (SessionStore.isCarrier()) {
            const carrier = this.props.job.carrier;
            return {
                shipment: this.props.job._id,
                payee_type: 'carrier',
                carrier,
            };
        }
        return {
            shipment: this.props.job._id,
            shipper_status: 'approved',
        };
    }
    render() {
        const { rows, loading } = this.state;
        const { isShipper } = this.props;
        if (loading) {
            return React.createElement(Loading, null);
        }
        return (React.createElement("div", { className: "w-full" },
            React.createElement(DataPoller, { frequency: POLL_INTERVAL, action: () => {
                    AccessorialRequestActionCreators.getAccessorialRequests(this.getRequest());
                } }),
            React.createElement("div", { className: "flex flex-wrap" },
                React.createElement(ViewReqTable, { shipper: isShipper, headers: VIEW_HEADERS, rows: rows, job: this.props.job, removeAccessorial: this.removeAccessorial, showUploadModal: this.showUploadModal, t: this.props.t, formatDateTime: this.props.formatDateTime })),
            React.createElement("div", null, this.state.showUploadModal && (React.createElement(AccessorialDocumentUploadModal, { show: this.state.showUploadModal, onHide: this.hideUploadModal, shipment: this.props.job, accessorial: this.state.selectedAccessorial })))));
    }
}
ViewAccessorialRequests.propTypes = {
    isShipper: PropTypes.bool,
    job: PropTypes.object,
    removeAccessorial: PropTypes.func,
};
ViewAccessorialRequests.defaultProps = {
    isShipper: false,
    job: {},
    removeAccessorial: () => {
        return null;
    },
};
class ViewReqTable extends Component {
    constructor(props) {
        super(props);
        this.handleShowAccessorialRequestModal = () => {
            this.setState({ showAccessorialRequestModal: true });
        };
        this.handleHideAccessorialRequestModal = () => {
            this.setState({ showAccessorialRequestModal: false });
        };
        this.handleSaveAccessorialRequestSuccess = () => {
            this.handleHideAccessorialRequestModal();
            this.fetchAccessorialRequests();
        };
        this.onDecline = async () => {
            const { accessorialToDecline: { id: _id, shipment: { _id: jobId }, }, accessorialToDecline, } = this.state;
            const accessorials = Object.assign({ _id, declineCarrier: true, declineShipper: true }, accessorialToDecline);
            const params = {
                sendEmail: false,
                accessorials: [accessorials],
                resolution_type: 'decline',
                jobId,
            };
            const user = SessionStore.getUser();
            if (user._type === 'Carrier') {
                const carrierPartner = SessionStore.getCarrierPartner();
                if (carrierPartner && user._id !== carrierPartner) {
                    params.carrierPartner = carrierPartner;
                }
            }
            const result = await ShipmentWebAPIUtils.declineAccessorial(params);
            if (result) {
                this.setState({
                    showConfirmDeclineModal: false,
                });
                this.fetchAccessorialRequests();
            }
        };
        this.removeSelectedAccessorial = (accessorial) => {
            const { removeAccessorial, shipper: isShipper } = this.props;
            if (isShipper) {
                removeAccessorial(accessorial);
            }
            else {
                this.setState({
                    accessorialToDecline: Object.assign({}, accessorial),
                    showConfirmDeclineModal: true,
                });
            }
        };
        this.canDecline = (accessorial) => {
            const { carrier_status, shipper_rate, shipper_status } = accessorial;
            if (shipper_status === 'approved')
                return false;
            const nonZeroShipperRate = shipper_rate && shipper_rate >= 0;
            return !nonZeroShipperRate && carrier_status === 'pending-admin';
        };
        this.renderColumns = (accessorial) => {
            const buttonClassName = {
                button: true,
            };
            let { status } = accessorial;
            const { accessorial: acc, rate, units, unit_name, total, created, updated, id, carrier_note, currency, shipperAutoDeclineDate, } = accessorial;
            const { shipper, t, formatDateTime } = this.props;
            const accessorialKey = `accessorial_${id}`;
            const totalKey = `total_${id}`;
            const createdKey = `created_${id}`;
            const updatedKey = `updated_${id}`;
            const statusKey = `status_${id}`;
            const tooltipDoc = (React.createElement(Tooltip, { id: "documentTooltip" }, t('ADD_DOCUMENT')));
            const tooltipCancel = (React.createElement(Tooltip, { id: "cancelTooltip" }, t('CANCEL_REQUEST')));
            if (status.indexOf('pending-') > -1) {
                status = 'pending';
            }
            const actionColumn = [
                React.createElement("td", { className: "px-6 py-4 font-medium whitespace-nowrap" },
                    React.createElement("button", { type: "button", className: classnames(buttonClassName), onClick: () => this.props.showUploadModal(accessorial), style: { padding: 0 }, disabled: status === 'declined' },
                        React.createElement(OverlayTrigger, { placement: "top", overlay: tooltipDoc },
                            React.createElement(Glyphicon, { glyph: "list-alt", style: { marginRight: '2px' } }))),
                    React.createElement(OverlayTrigger, { placement: "right", overlay: tooltipCancel },
                        React.createElement("button", { type: "button", className: classnames(buttonClassName), onClick: () => this.removeSelectedAccessorial(accessorial), disabled: !this.canDecline(accessorial) },
                            React.createElement(Glyphicon, { glyph: "remove" })))),
            ];
            let color;
            switch (status) {
                case 'accepted':
                    color = 'blue';
                    break;
                case 'pending':
                    color = 'yellow';
                    break;
                case 'approved':
                    color = 'brand';
                    break;
                case 'declined':
                    color = 'red';
                    break;
                default:
                    color = 'gray';
            }
            const newColumnData = [
                React.createElement("td", { className: "py-4 text-sm border-b border-solid border-grey-lighter text-black-500", key: accessorialKey }, titleize(t(sluggify(acc)))),
                React.createElement("td", { className: "py-4 text-sm border-b border-solid border-grey-lighter text-black-500", key: totalKey },
                    React.createElement("div", { className: "flex flex-wrap" },
                        React.createElement("div", null, formatMoney(total, currency)),
                        unit_name === 'flat' && React.createElement("span", null, "\u00A0(Flat)"),
                        units > 1 && [
                            React.createElement("div", null,
                                " \u00A0(",
                                formatMoney(rate, currency)),
                            React.createElement("span", null, "\u00A0X\u00A0"),
                            React.createElement("div", null, units),
                            React.createElement("span", null, ")"),
                        ])),
                React.createElement("td", { className: "py-4 text-sm border-b border-solid border-grey-lighter text-black-500", style: { width: '50px' }, key: createdKey }, formatDateTime(created, DEFAULT_TIMEZONE)),
                React.createElement("td", { className: "text-sm border-b border-solid rounded border-grey-lighter text-black-500", key: statusKey },
                    React.createElement(Badge, { color: color }, titleize(t(sluggify(status))))),
                React.createElement("td", { className: "py-4 text-sm border-b border-solid border-grey-lighter text-black-500", style: { width: '50px' }, key: updatedKey }, formatDateTime(updated, DEFAULT_TIMEZONE)),
            ];
            if (featureEnabled(CONFIGURED_FEATURES.SSR)) {
                const { job } = this.props;
                if (!(shipperAutoDeclineDate && job)) {
                    newColumnData.push(React.createElement("td", null));
                }
                else {
                    const timezone = getShipmentTimezone(job);
                    newColumnData.push(React.createElement("td", { className: "py-4 text-sm border-b border-solid border-grey-lighter text-red-700", style: { width: '150px' } },
                        React.createElement("div", { className: "flex justify-between" },
                            React.createElement(ExclamationIcon, { className: "w-6 h-6 m-auto" }),
                            React.createElement("p", { className: "pl-1" }, `Due on ${moment.tz(shipperAutoDeclineDate, timezone).format('L')}`))));
                }
            }
            if (!shipper) {
                newColumnData.push(actionColumn);
                newColumnData
                    .splice(4, 0, React.createElement("td", { className: "py-4 text-sm border-b border-solid border-grey-lighter text-black-500", style: { width: '150px' }, key: updatedKey }, carrier_note))
                    .join();
            }
            return newColumnData;
        };
        this.VIEW_REQ_TOOLTIPS = {
            STATUS: (React.createElement(Tooltip, { id: "statusToolip" },
                React.createElement("ol", null,
                    React.createElement("li", null, this.props.t('VIEW_REQ_TOOLTIP_1')),
                    React.createElement("li", null, this.props.t('VIEW_REQ_TOOLTIP_2')),
                    React.createElement("li", null, this.props.shipper
                        ? this.props.t('VIEW_REQ_TOOLTIP_3_A')
                        : this.props.t('VIEW_REQ_TOOLTIP_3_B')),
                    React.createElement("li", null, this.props.t('VIEW_REQ_TOOLTIP_4'))))),
        };
        this.renderHeader = () => {
            let columnHeaders = this.props.headers;
            if (this.props.shipper) {
                columnHeaders = columnHeaders.filter((el) => el !== 'REMARK');
            }
            const { t } = this.props;
            return (React.createElement("thead", null,
                React.createElement("tr", { key: "accessorial-headers" }, columnHeaders.map((col) => {
                    if (this.VIEW_REQ_TOOLTIPS[col]) {
                        return (React.createElement("th", { key: col, className: "text-sm font-bold text-grey-darker" },
                            t(col),
                            React.createElement(OverlayTrigger, { id: `tooltip_${col}`, placement: "top", overlay: this.VIEW_REQ_TOOLTIPS[col] },
                                React.createElement(Glyphicon, { glyph: "info-sign", className: "pl-1 text-grey-darker" }))));
                    }
                    return (React.createElement("th", { key: col, className: "text-sm font-bold text-grey-darker" }, t(col)));
                }))));
        };
        this.state = {
            showConfirmDeclineModal: false,
            accessorialToDecline: {},
            showAccessorialRequestModal: false,
            hasMissingDocuments: (props.rows || []).some((row) => row.missing_docs),
        };
    }
    fetchAccessorialRequests() {
        AccessorialRequestActionCreators.getAccessorialRequests(this.getRequest());
    }
    renderAccessorialMissingDocumentsError() {
        const { t } = this.props;
        const { hasMissingDocuments } = this.state;
        if (featureEnabled(CONFIGURED_FEATURES.SSR) && SessionStore.isCarrier()) {
            if (hasMissingDocuments) {
                return (React.createElement(CargomaticAlert, { className: "my-4", type: "error" }, t('ACCESSORIALS_WITH_MISSING_DOCUMENTS')));
            }
        }
        return null;
    }
    renderRow(row) {
        const columns = this.renderColumns(row);
        return (React.createElement("tr", { key: row.id, className: "p-1" }, columns));
    }
    renderBody() {
        const { rows } = this.props;
        return React.createElement("tbody", null, rows.map((row) => this.renderRow(row)));
    }
    render() {
        const { title, rows, shipper, t, job } = this.props;
        return (React.createElement("div", { className: "w-full" },
            React.createElement("div", { className: "flex justify-between" },
                React.createElement("h4", { className: "mb-2 text-grey-darker" }, t(title)),
                !shipper && (React.createElement(AddButton, { onClick: this.handleShowAccessorialRequestModal, disabled: isShipmentCanceled(job) }))),
            featureEnabled(CONFIGURED_FEATURES.SSR) &&
                this.renderAccessorialMissingDocumentsError(),
            React.createElement("hr", null),
            React.createElement("div", { className: "stop-rows" },
                !rows ||
                    (rows.length === 0 && React.createElement("span", null, t('NO_ACCESSORIAL_REQUESTS'))),
                rows && rows.length > 0 && (React.createElement("table", { className: "table" },
                    this.renderHeader(),
                    this.renderBody())),
                React.createElement(ConfirmModal, { show: this.state.showConfirmDeclineModal, title: t('DECLINE'), message: t('ACCESSORIAL_REQUEST_DECLINE'), onHide: () => this.setState({ showConfirmDeclineModal: false }), onConfirm: this.onDecline })),
            this.state.showAccessorialRequestModal && (React.createElement(CargomaticModal, { show: this.state.showAccessorialRequestModal, onHide: this.handleHideAccessorialRequestModal, title: `${t('CREATE_ACCESSORIAL_REQUEST')}` },
                React.createElement(AccessorialRequestForm, { job: this.props.job, accessorialRequest: this.state.selectedAccessorial, existingRequests: ExceptionStore.getAllAccessorialRequests(), onSaveSuccess: this.handleSaveAccessorialRequestSuccess, onCancel: this.handleHideAccessorialRequestModal })))));
    }
}
ViewReqTable.propTypes = {
    title: PropTypes.string,
    shipper: PropTypes.bool,
    headers: PropTypes.array,
    rows: PropTypes.array,
    removeAccessorial: PropTypes.func,
    showUploadModal: PropTypes.func,
};
ViewReqTable.defaultProps = {
    headers: [],
    rows: [],
    title: 'ACCESSORIAL_REQUESTS',
    showUploadModal: () => {
        return null;
    },
    shipper: false,
    removeAccessorial: () => {
        return null;
    },
};
export default withTranslation()(withLocaleContext(ViewAccessorialRequests));
